import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { OfferSettingsJsonType } from '@bb/domain/dist/types';

export type OfferDetailsType = {
  offerCount: number;
  offerSettings:
    | Pick<
        OfferSettingsJsonType,
        | 'acceptedAnytime'
        | 'offerDate'
        | 'otherInstructions'
        | 'preemptive'
        | 'registration'
        | 'requestIrrevocable'
      >
    | undefined;
  offerSubmissions: string;
};

const getDashOfferDetails = async (dashboardId: string) => {
  const config: AxiosRequestConfig = {
    url: `/external/dash/${dashboardId}/offer_details`,
    method: 'get',
  };

  const { data } = await axios.request<OfferDetailsType>(config);

  return data;
};

export default getDashOfferDetails;
